import { IPreloadedState } from 'shared/types/redux';

export const selectPeriod = (state: IPreloadedState) => state.marketTrends.filters.period;
